<script setup lang="ts">
import { Toaster } from 'vue-sonner'
</script>

<template>
  <RouterView class="mx-auto max-w-sm" />
  <Toaster position="top-right" richColors closeButton />

</template>


<style>

</style>
